import { createFileRoute } from "@tanstack/react-router";
import I18nAudit from "@/pages/admin/I18nAudit";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/admin/i18n-audit")({
  head: () => ({
    meta: [
      { title: "i18n Audit — Missing Translation Keys | Statlign Admin" },
      { name: "description", content: "Per-locale coverage of Statlign's translation dictionaries. Trigger bulk translation and download merged locale files." },
      { property: "og:title", content: "i18n Audit — Missing Translation Keys | Statlign Admin" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Per-locale coverage of Statlign's translation dictionaries. Trigger bulk translation and download merged locale files." },
      { name: "twitter:title", content: "i18n Audit — Missing Translation Keys | Statlign Admin" },
      { name: "twitter:description", content: "Per-locale coverage of Statlign's translation dictionaries. Trigger bulk translation and download merged locale files." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <I18nAudit />
      </ProtectedRoute>
    </MainLayout>
  ),
});
